import axios from "axios";

// Shared axios client for authenticated calls (sends session cookie).
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;
